import { render } from "./DetailIngredientDescriber.vue?vue&type=template&id=55aed4da"
import script from "./DetailIngredientDescriber.vue?vue&type=script&lang=js"
export * from "./DetailIngredientDescriber.vue?vue&type=script&lang=js"
script.render = render

export default script